module.exports = __webpack_public_path__ + "static/media/power-none.8e23e1e6.png";